// import React, { useEffect } from 'react';
import {RouterProvider} from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";

import {router} from "@shared/router/router";
import './styles/transition.css'

// import { APP_STORE_URL } from "./shared/config/env";

function App() {
  // useEffect(() => {
  //   const isIphone = /iPhone|iPod/.test(navigator.userAgent);
  //
  //   if (isIphone) {
  //     window.location.replace(APP_STORE_URL);
  //   }
  // }, []);

  return (
      <HelmetProvider>
        <RouterProvider router={router} />
      </HelmetProvider>
  );
}

export default App;
